
    var runtime = require('vue-svg-component-runtime')
    module.exports = {
      __esModule: true,
      default: runtime.svgComponent({
  "tag": "svg",
  "attrsMap": {
    "viewBox": "0 0 48 48",
    "xmlns": "http://www.w3.org/2000/svg"
  },
  "children": [
    {
      "tag": "title"
    },
    {
      "tag": "g",
      "attrsMap": {
        "data-name": "27-Report",
        "id": "_27-Report"
      },
      "children": [
        {
          "tag": "path",
          "attrsMap": {
            "d": "M45,4H30V1a1,1,0,0,0-1-1H19a1,1,0,0,0-1,1V4H3A3,3,0,0,0,0,7V37a1,1,0,0,0,1,1H23v2H22a1,1,0,0,0-1,1v6a1,1,0,0,0,1,1h4a1,1,0,0,0,1-1V41a1,1,0,0,0-1-1H25V38H47a1,1,0,0,0,1-1V7A3,3,0,0,0,45,4ZM25,46H23V42h2ZM46,36H2V34H46Zm0-4H2V7A1,1,0,0,1,3,6H25V4H20V2h8V5a1,1,0,0,0,1,1H45a1,1,0,0,1,1,1Z"
          }
        },
        {
          "tag": "path",
          "attrsMap": {
            "d": "M39,10H33v2h3.59l-6,6H16a1,1,0,0,0-.71.29l-8,8,1.41,1.41L16.41,20H31a1,1,0,0,0,.71-.29L38,13.41V16h2V11A1,1,0,0,0,39,10Z"
          }
        }
      ]
    }
  ]
})
    }
  